<!-- Summary: how far along, plus a key to the four states used below -->
<div class="ms-summary" *ngIf="lessons?.length">
    <div class="ms-summary__top">
        <div>
            <span class="ms-summary__count">{{completedCount}}<span class="ms-summary__of"> / {{lessons.length}}</span></span>
            <span class="ms-summary__label">lesson{{lessons.length === 1 ? '' : 's'}} completed</span>
        </div>
        <span class="ms-summary__pct">{{completedPercent}}%</span>
    </div>
    <div class="ms-summary__bar" role="progressbar" [attr.aria-valuenow]="completedPercent" aria-valuemin="0" aria-valuemax="100">
        <div [style.width.%]="completedPercent"></div>
    </div>
    <ul class="ms-legend">
        <li><span class="ms-key ms-key--done"><i class="fas fa-check"></i></span> Completed</li>
        <li><span class="ms-key ms-key--current"></span> Up next</li>
        <li><span class="ms-key ms-key--upcoming"></span> Upcoming</li>
        <li *ngIf="showsDeadlines"><span class="ms-key ms-key--overdue"><i class="fas fa-exclamation"></i></span> Overdue</li>
    </ul>
</div>

<div class="ms-track">
    <button type="button" class="ms-nav ms-nav--prev" (click)="scrollBy(-1)" aria-label="Scroll to earlier lessons">
        <i class="fas fa-chevron-left" aria-hidden="true"></i>
    </button>

    <div class="lesson-timeline-wrapper" id="timeline">
        <div class="lesson-timeline">
            <div *ngFor="let milestone of lessons; let i = index"
                 class="milestone"
                 [class.is-done]="state(milestone) === 'done'"
                 [class.is-overdue]="state(milestone) === 'overdue'"
                 [class.is-current]="state(milestone) === 'current'"
                 [class.is-upcoming]="state(milestone) === 'upcoming'"
                 [class.has-connector]="!isLast(i)"
                 [class.connector-done]="connectorDone(milestone)"
                 [id]="milestone.classposition">

                <div class="circle" aria-hidden="true">
                    <i class="fas fa-check" *ngIf="state(milestone) === 'done'"></i>
                    <i class="fas fa-exclamation" *ngIf="state(milestone) === 'overdue'"></i>
                    <span class="circle__dot" *ngIf="state(milestone) === 'current' || state(milestone) === 'upcoming'"></span>
                </div>

                <div class="content">
                    <span class="content__step">Lesson {{i + 1}}</span>

                    <span class="content__pill" *ngIf="hasDeadline(milestone)">
                        <ng-container [ngSwitch]="state(milestone)">
                            <ng-container *ngSwitchCase="'done'">Completed</ng-container>
                            <ng-container *ngSwitchCase="'overdue'">Overdue {{ setDate(milestone) | date: 'd MMM' }}</ng-container>
                            <ng-container *ngSwitchDefault>Due {{ setDate(milestone) | date: 'd MMM' }}</ng-container>
                        </ng-container>
                    </span>
                    <span class="content__pill content__pill--plain" *ngIf="!hasDeadline(milestone) && state(milestone) === 'done'">Completed</span>
                    <span class="content__pill" *ngIf="!hasDeadline(milestone) && state(milestone) === 'current'">In progress</span>

                    <h3 class="content__title" [title]="milestone.title">{{milestone.title}}</h3>
                    <!-- description is stored as HTML, so it is rendered through the same
                         sanitizer pipe the rest of the app uses. Interpolating it printed the
                         tags as literal text. A div, not a p — the value contains block tags. -->
                    <div class="content__description" *ngIf="milestone.description"
                         [innerHTML]="milestone.description | customhtmlsanitizer"></div>
                </div>
            </div>
        </div>
    </div>

    <button type="button" class="ms-nav ms-nav--next" (click)="scrollBy(1)" aria-label="Scroll to later lessons">
        <i class="fas fa-chevron-right" aria-hidden="true"></i>
    </button>
</div>
